export class POLEnvironmentConstants {
  public static get env(): string {
    return window.ENVIRONMENT.env;
  }
  public static get baseUrl(): string {
    return window.ENVIRONMENT.baseUrl;
  }
  public static get apiKey(): string {
    return window.ENVIRONMENT.apiKey;
  }
  public static get subscriptionKey(): string {
    return window.ENVIRONMENT.subscriptionKey;
  }
  public static get instrumentationKey(): string {
    return window.ENVIRONMENT.applicationInsights.instrumentationKey;
  }
}
